export default "__VITE_ASSET__Xy4ZomyV__"